import { render, staticRenderFns } from "./PayRangeVersionTimeline.vue?vue&type=template&id=9487c526&scoped=true"
import script from "./PayRangeVersionTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionTimeline.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeVersionTimeline.vue?vue&type=style&index=0&id=9487c526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9487c526",
  null
  
)

export default component.exports